import * as Keycloak from 'keycloak-js';
import React, { createContext, useState } from 'react';
import { inTemporaryStore } from '../utils/storage.util.js';
import { consumePostLoginRedirectPath } from '../utils/authRedirect.util';
import { BaSeLoadingPage } from '@base/react';
import './styleLoading.scss';


export const keycloak = Keycloak('/keycloak.json');

const AuthContext = createContext({
  keycloak: keycloak,
  authenticated: false
});

const keycloakLogout = keycloak.logout.bind(keycloak);

export const AuthProvider = ({ children }) => {
  const [initialized, setInitalized] = useState(false);
  const [authenticated, setAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);

  React.useEffect(() => {
    keycloak
      .init({
        useNonce: false,
        onLoad: 'check-sso',
        silentCheckSsoRedirectUri:  window.location.origin + '/silent-check-sso.html',
        checkLoginIframe: false,
        enableLogging: true,
      })
      .then((auth) => {
        console.log('keycloak is auth: ', auth);
        if (auth) {
          setAuth();
          handlePostLoginRedirect();
        }
        setInitalized(true);
      })
      .catch((error) => console.error('Erro ao inicializar o keycloak:', error))
  }, []);

  keycloak.onReady = function (authenticated) {
    console.log('Keycloak onReady', authenticated)
  };

  keycloak.onAuthSuccess = function () {
    console.log('Keycloak onAuthSuccess')
    setAuth();
    handlePostLoginRedirect();
  };

  keycloak.onAuthError = function (errorData) {
    console.log('Keycloak onAuthError', errorData)
    // cleanAuth();
  };

  keycloak.onAuthRefreshSuccess = function () {
    console.log('Keycloak onAuthRefreshSuccess')
    setAuth();
  };

  keycloak.onAuthRefreshError = function () {
    console.log('Keycloak onAuthRefreshError')
    cleanAuth();
  };

  keycloak.logout = () => {
    console.log('Keycloak logout')
    keycloakLogout({ redirectUri: window?.location?.origin });
  };


  keycloak.onAuthLogout = function () {
    console.log('Keycloak onAuthLogout')
    cleanAuth();
  };

  keycloak.onTokenExpired = () => {
    keycloak.updateToken(5).then((refreshed) => {
      if (refreshed) {
        setAuth();
      }
    });
  };


  const handlePostLoginRedirect = () => {
    const redirectPath = consumePostLoginRedirectPath();
    const currentPath = `${window.location.pathname}${window.location.search}${window.location.hash}`;

    if (!redirectPath || redirectPath === '/forbidden' || redirectPath === currentPath) {
      return;
    }

    window.location.href = redirectPath;
  };

  const setAuth = async () => {
    console.log('setAuth')
    setAuthenticated(true);
    setUser(keycloak.tokenParsed);
    setToken(keycloak.token);
    inTemporaryStore.setItem('token', keycloak.token);
    inTemporaryStore.setItem('usuario', keycloak.tokenParsed);
  };

  const cleanAuth = () => {
    console.log('cleanAuth')
    setAuthenticated(false);
    setUser(null);
    setToken(null);

    inTemporaryStore.removeItem('token');
    inTemporaryStore.removeItem('usuario');
  };
  
  let values = {
    keycloak,
    authenticated,
    user,
    token,
  };
  
  return (
      <>
        {
          (initialized)
              ? <AuthContext.Provider value={values}>{children} </AuthContext.Provider>
              : <div className="baseLoading"><BaSeLoadingPage/></div>
        }
      </>
  );
};

export default AuthContext;
